/**
 * Flat token list for host display: n0, o0, n1, o1, n2, …
 */
export function buildQuickMathTokens(
  numbers: number[],
  ops: ('+' | '-')[]
): Array<{ key: string; text: string }> {
  const items: Array<{ key: string; text: string }> = [];
  if (!numbers.length) return items;
  items.push({ key: 'n0', text: String(numbers[0]) });
  for (let i = 0; i < ops.length; i++) {
    items.push({ key: `o${i}`, text: ops[i] });
    items.push({ key: `n${i + 1}`, text: String(numbers[i + 1]) });
  }
  return items;
}

/** How many tokens are visible at reveal step `step` (0 = first number + op + second number). */
export function quickMathVisibleTokenCount(step: number, totalTokens: number): number {
  const n = 3 + step * 2;
  return Math.min(totalTokens, n);
}

export function quickMathMaxRevealStep(totalTokens: number): number {
  if (totalTokens <= 3) return 0;
  return Math.ceil((totalTokens - 3) / 2);
}
